import { Avatar } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { IoIosCheckmark } from "react-icons/io";
import validator from "validator";
import Circle_Date_Component from "../common/Circle_Date_Component";
import dayjs from "dayjs";
import TaskActivity from "../../views/admin/taskDetails/TaskActivity";
import { debounce } from "lodash";
import { errorNotification } from "../toast-notification/common-toast";
import { deleteRequest, patchRequest, postRequest } from "../axiosClient";
import { ADD_SUB_TASK, DELETE_TASK_BY_ID, UPDATE_SUB_TASK } from "../utils";
import { useNavigate } from "react-router-dom";
import deleteIcon from "../../components/assets/bin.svg";

const Subtask_Section = ({
  index,
  subtask,
  setSubtask,
  assignee,
  role_access,
  selectedTaskId,
  statusOption,
  getTask,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [task, setTask] = useState(subtask[index]);
  const [updatedTask, setUpdatedTask] = useState(subtask[index]);
  const titleRef = useRef();
  const hasMounted = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!task?.id) {
      handleTextClick();
    }
  }, [task]);

  const updateTask = async (payload) => {
    console.log(payload);
    if (!task.id) {
      return;
    }
    //Don't make API call when still focus is true
    if (titleRef.current && document.activeElement === titleRef.current) {
      return;
    } else {
      previousTask.current = task;
      previousUpdatedTask.current = updatedTask;
    }

    if (payload?.title !== undefined && validator.isEmpty(payload.title)) {
      // getTask();
      // setUpdatedTask(updateTask);
      errorNotification("Task title can not be empty");
      return;
    }
    const updatedPayload = {
      sub_task_id: payload?.id,
      title: payload?.title,
      due_date: payload?.due_date,
      is_completed: payload?.is_completed,
    };

    if (payload?.due_date !== undefined) {
      updatedPayload.due_date =
        typeof payload.due_date === "string" && payload.due_date.trim() === ""
          ? null
          : payload.due_date;
    }

    try {
      const res = await patchRequest(
        `${UPDATE_SUB_TASK}`,
        updatedPayload,
        navigate
      );
      if (res?.response && res?.response.data.success) {
        console.log("task Updated");
      } else {
        // getTask();
        errorNotification(res?.errormessage);
      }
      // setUpdatedTask(updateTask);
    } catch (error) {
      // getTask();
      console.error(error);
      errorNotification(error);
    }
  };

  const addTask = async (payload) => {
    const addPayload = {
      ...payload,
      parent_id: selectedTaskId,
      status_id: statusOption[0].value,
    };
    if (payload?.due_date !== undefined) {
      addPayload.due_date =
        typeof payload.due_date === "string" && payload.due_date.trim() === ""
          ? null
          : payload.due_date;
    }
    try {
      const res = await postRequest(`${ADD_SUB_TASK}`, addPayload, navigate);
      if (res?.response && res?.response?.data?.data) {
        console.log("task add");
        const NewTask = {
          title: res?.response?.data?.data?.title,
          due_date: res?.response?.data?.data?.due_date,
          is_completed: res?.response?.data?.data?.is_completed,
          id: res?.response?.data?.data?.id,
        };
        setTask(NewTask);
        setUpdatedTask(NewTask);
        const newSubtasks = [...subtask];
        newSubtasks[index] = res?.response?.data?.data;
        setSubtask(newSubtasks);
      } else {
        errorNotification(res?.errormessage);
      }
      // setUpdatedTask(updateTask);
    } catch (error) {
      // getTask();
      console.error(error);
      errorNotification(error);
    }
  };

  const deleteTask = async (index) => {
    try {
      const res = await deleteRequest(
        `${DELETE_TASK_BY_ID}?task_id=${subtask?.[index]?.id}`,
        navigate
      );
      if (res?.response && res?.response.data.success) {
        console.log("task deleted");

        getTask(selectedTaskId);
      } else {
        errorNotification(res?.errormessage);
      }
      // setUpdatedTask(updateTask);
    } catch (error) {
      console.error(error);
      errorNotification(error);
    }
  };

  const debouncedUpdateTask = debounce((prop) => {
    updateTask(prop);
    // getTask(selectedTaskId);
  }, 100);

  const previousTask = useRef(task);
  const previousUpdatedTask = useRef(updatedTask);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    // Check if both task and updatedTask have changed
    const taskChanged = previousTask.current !== task;
    const updatedTaskChanged = previousUpdatedTask.current !== updatedTask;

    if (taskChanged && updatedTaskChanged) {
      if (!role_access) {
        return;
      }
      debouncedUpdateTask(updatedTask);
    }

    // Update refs to current values
    previousTask.current = task;
    previousUpdatedTask.current = updatedTask;

    return () => {
      debouncedUpdateTask.cancel();
    };
  }, [task, updatedTask]);

  const handleTextClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e) => {
    setTask({
      ...task,
      title: e.target.value,
    });
    setUpdatedTask({
      ...updatedTask,
      title: e.target.value,
    });
  };

  const handleBlur = () => {
    if (task.title !== "") {
      setIsEditing(false);
    }

    if (!task?.id) {
      if (task.title !== "") {
        addTask(updatedTask);
      }
      const newSubtasks = [...subtask];
      newSubtasks.pop();
      setSubtask(newSubtasks);
    }
    updateTask(updatedTask);
  };

  const handleChange = (newValue, formattedDate) => {
    if (formattedDate?.validationError) {
      return;
    }
    const value = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;
    setTask({
      ...task,
      due_date: value,
    });
    setUpdatedTask({
      ...updatedTask,
      due_date: value,
    });
  };

  return (
   <div className="flex justify-between items-center min-h-8 py-1 text-xs border-b border-gray-300 hover:bg-gray-200">
  {/* Left side: Checkbox + Title */}
  <div className="flex items-center gap-2">
    {/* Checkbox */}
    <div
      className={`w-5 h-5 rounded-full border flex items-center justify-center
        ${task.is_completed ? "bg-green-600 text-white" : "bg-white text-black"}
        cursor-pointer`}
      onClick={(e) => {
        e.stopPropagation();
        const change = !task.is_completed;
        setTask({ ...task, is_completed: change });
        setUpdatedTask({ ...updatedTask, is_completed: change });
      }}
    >
      <IoIosCheckmark className="text-base" />
    </div>

    {/* Title input or text */}
    {isEditing ? (
      <input
        type="text"
        value={task?.title}
        ref={titleRef}
        onChange={handleInputChange}
        onBlur={handleBlur}
        autoFocus
        className="border px-2 py-1 text-sm h-7"
      />
    ) : (
      <span onClick={handleTextClick} className="cursor-pointer leading-5">
        {task?.title}
      </span>
    )}
  </div>

  {/* Right side: Date + Delete */}
  <div className="flex items-center gap-2">
    {/* Due Date */}
    <div className="h-7 flex items-center">
      <Circle_Date_Component
        value={dayjs(task?.due_date)}
        onChange={handleChange}
      />
    </div>

    {/* Delete Icon */}
    <div
      className="cursor-pointer flex items-center justify-center"
      onClick={(e) => {
        e.stopPropagation();
        deleteTask(index);
      }}
    >
      <img src={deleteIcon} alt="delete" className="h-4 w-4 mr-2" />
    </div>
  </div>
</div>

  );
};

export default Subtask_Section;
